import { ICompileService, IServiceProvider, Injectable } from "angular";
import { ColDef } from "./colDef";
import { Dictionary } from "lodash";

export const vsServiceName = "columnDefinitionSetService";
export const vsProviderName = `${vsServiceName}Provider`;

export class ColumnDefinitionSetServiceProvider implements IServiceProvider {
  $get: any = [
    "$injector",
    ($injector: angular.auto.IInjectorService) => {
      return new ColumnDefinitionSetService(
        $injector,
        this.columnDefinitionSets
      );
    },
  ];

  private columnDefinitionSets: Dictionary<
    Injectable<(...args: any[]) => ColDef[]>
  > = {};

  addColumnDefinitionSet(
    name: string,
    columns: Injectable<(...args: any[]) => ColDef[]>
  ) {
    this.columnDefinitionSets[name] = columns;
  }
}

export class ColumnDefinitionSetService {
  constructor(
    private readonly $injector: angular.auto.IInjectorService,
    private readonly columnDefinitionSets: Dictionary<
      Injectable<(...args: any[]) => ColDef[]>
    >
  ) {}

  getColumnDefinitionSet(name: string): ColDef[] {
    return this.$injector.invoke(this.columnDefinitionSets[name]);
  }
}
